"use client";
import {useEffect,useState} from 'react';
import {LoginModal} from '@/components/login-modal';
import {closeBiteLogin} from '@/lib/bite-signup-referral';
import './bite-login.css';

export function BiteLoginHost() {
  const [next,setNext]=useState<string|null>(null);
  useEffect(()=>{
    const open=(event:Event)=>{
      const value=(event as CustomEvent<{next:string}>).detail?.next;
      if(typeof value!=='string')return;
      event.preventDefault();setNext(value);
    };
    window.addEventListener('bite:login',open);
    return()=>window.removeEventListener('bite:login',open);
  },[]);
  return <LoginModal variant="bite" open={next!==null} returnTo={next||'/bite/home'} onOpenChange={open=>{if(!open){setNext(null);closeBiteLogin();}}}/>;
}
